<template>
  <div class="list-item">
    <div class="list-item__content">
      <div class="list-item__title">{{ title }}</div>
      <div class="list-item__description">
        {{ description }}
      </div>
    </div>
    <div class="list-item__actions">
      <ui-button
        color="primary"
        icon="icon-edit"
        minWidth="200"
        @click="$emit('edit')"
      >
        {{ $t("message.common.edit") }}
      </ui-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusinessStoreLocatorListItem",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
.list-item {
  display: flex;
  align-items: center;
  gap: $spacing * 4;
  width: 100%;
  padding: $spacing * 4 0;
  border-bottom: 1px solid $gray-300;

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: $spacing * 1.5;
  }

  &__title {
    @include font-size(22px);
    font-weight: 600;
    line-height: 1em;
  }

  &__description {
    @include font-size(14px);
  }
}
</style>
